module.exports = __webpack_public_path__ + "static/material-silver.891823fe.svg";